import React, { useState } from "react";

const ProductDescriptionTabs = ({
  description,
  otherDescription,
  additionalInformation,
}) => {
  const [activeTab, setActiveTab] = useState("description");

  console.log("otherDescription", otherDescription);

  return (
    <div className="mt-10 max-w-6xl mx-auto px-4">
      {/* Tabs */}
      <div className="flex flex-wrap border-b border-pastelPurple">
        <button
          className={`px-4 py-2 font-semibold transition ${
            activeTab === "description"
              ? "border-b-2 border-themePurple text-themePurple"
              : "text-[#5f5870] hover:text-darkPurple"
          }`}
          onClick={() => setActiveTab("description")}
        >
          Description
        </button>

        <button
          className={`px-4 py-2 font-semibold transition ${
            activeTab === "otherDescription"
              ? "border-b-2 border-themePurple text-themePurple"
              : "text-[#5f5870] hover:text-darkPurple"
          }`}
          onClick={() => setActiveTab("otherDescription")}
        >
          Other Description
        </button>

        <button
          className={`px-4 py-2 font-semibold transition ${
            activeTab === "shipping"
              ? "border-b-2 border-themePurple text-themePurple"
              : "text-[#5f5870] hover:text-darkPurple"
          }`}
          onClick={() => setActiveTab("shipping")}
        >
          Shipping & Return
        </button>
      </div>

      {/* Tab Panels */}
      <div className="mt-4 p-4 border border-pastelPurple rounded bg-lightPastelPurple min-h-[150px]">
        {activeTab === "description" && (
          <div
            className="prose max-w-none text-[#5f5870] prose-headings:text-darkPurple prose-a:text-themePurple"
            dangerouslySetInnerHTML={{ __html: otherDescription }}
          />
        )}

        {activeTab === "otherDescription" && (
          <div
            className="prose max-w-none text-[#5f5870] prose-headings:text-darkPurple prose-a:text-themePurple"
            dangerouslySetInnerHTML={{ __html: additionalInformation }}
          />
        )}

        {activeTab === "shipping" && (
          <div className="text-[#5f5870] space-y-8">
            {/* Shipping Policy */}
            <div className="bg-white border border-pastelPurple rounded-xl p-6 shadow-sm">
              <h3 className="text-xl font-semibold mb-4 flex items-center gap-2 text-themePurple">
                🚚 Shipping Policy
              </h3>

              <ul className="space-y-2 list-disc list-inside">
                <li>Order processing time is 2–4 business days after design approval.</li>
                <li>Standard shipping takes 5–7 business days.</li>
                <li>Rush shipping options are available at checkout.</li>
                <li>Tracking details will be shared via email once shipped.</li>
              </ul>
            </div>

            {/* Returns & Refunds */}
            <div className="bg-white border border-pastelPurple rounded-xl p-6 shadow-sm">
              <h3 className="text-xl font-semibold mb-4 flex items-center gap-2 text-themePurple">
                🔄 Returns & Refunds
              </h3>

              <ul className="space-y-2 list-disc list-inside">
                <li>All products are custom-made; returns are not accepted.</li>
                <li>Refunds or replacements are only offered for damaged or incorrect items.</li>
                <li>Issues must be reported within 48 hours of delivery.</li>
                <li>Orders cannot be canceled once production has started.</li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductDescriptionTabs;